import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { branch, compose, renderComponent, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { contentSorting, eventSorting, searchTileType } from '../../../../../constants';
import { mapRecommendedResult } from '../../../../../services';
import { businessSelector } from '../../../../../state/modules/business';
import { searchTileActions, searchTileSelector } from '../../../../../state/modules/search-tile';
import { noCapMap } from '../../../../../utils';
import Loading from '../../../loading';
import ContentTile from '../../partials/content-tile';
import CourseTile from '../../partials/course-tile';
import EventTile from '../../partials/event-tile';

const ContentList = ({
  searchResult,
  recommendedResult,
  isFetching,
  loadMore
}) => (
    <div id='section--training' className='layout--section'>
      <section id='tiles--area-of-advice'>
        <Grid>
          {
            noCapMap((chunk, chunkIndex) =>
              <Row key={chunkIndex} className='card-gutter row-slider gap-bottom'>
                {
                  noCapMap((searchTile, index) =>
                    <Col key={index} xs={12} md={3}>
                      {
                        searchTile.type === searchTileType.Event ?
                          <EventTile {...searchTile} /> : null
                      }
                      {
                        searchTile.type === searchTileType.Course ?
                          <CourseTile {...searchTile} /> : null
                      }
                      {
                        searchTile.type === searchTileType.Content ?
                          <ContentTile {...searchTile} /> : null
                      }
                    </Col>
                  )(chunk)
                }
              </Row>
            )(fp.flow(
              recommendedResult,
              fp.chunk(4)
            )(searchResult))
          }
          {
            isFetching ?
              <Loading /> :
              null
          }
          {
            searchResult.hits > searchResult.searchTiles.length ?
              <Row className='no-gutter row-slider'>
                <Col xs={12} md={4} mdOffset={4}>
                  <Button className='large full' onClick={loadMore}>
                    Load More Content
                  </Button>
                </Col>
              </Row> :
              null
          }
        </Grid>
      </section>
    </div>
  );

const NoSearchResult = ({ searchTileType: tileType }) => (
  <h2 className='text-center'>There is no {tileType === searchTileType.Event ? 'event' : 'content'} matching your search.</h2>
);

const NoContentMessage = ({ searchTileType: tileType }) => (
  <h2 className='text-center'>There is no {tileType === searchTileType.Event ? 'event' : 'content'} in the CPD category.</h2>
);

const mapStateToProps = (state) => ({
  searchResult: searchTileSelector(state),
  isFetching: state.searchTile.isFetching,
  recommendedResult: mapRecommendedResult(state.industry.cpdCategorys, state.publisher.publishers, businessSelector(state), state.user.currentUserBookmarks)
});

const mapDispatchToProps = (dispatch) => ({
  loadMoreContent: bindActionCreators(searchTileActions.searchTile.loadMore, dispatch),
  goTo: bindActionCreators(push, dispatch)
});

export const userCpdCategoryIdParam = (userCpdCategorys) => fp.join(',', fp.map((a) => a.cpdCategoryId)(userCpdCategorys));

export const searchTileFilter = (
  searchTileType,
  cpdCategoryId,
  currentSort,
  userCpdCategorys,
  query,
  publishers,
  businessId,
  associations,
  locations,
  minCpdHours,
  maxCpdHours,
  contentType,
  isBookmarkedOnly,
) => {
  const sort = fp.get(currentSort, {
    ...contentSorting,
    ...eventSorting
  });
  return {
    searchTileType: searchTileType,
    titleTags: query,
    cpdCategorys: cpdCategoryId || userCpdCategoryIdParam(userCpdCategorys),
    sort: fp.join(',', [sort.field, sort.order]),
    publishers: fp.join(',')(publishers),
    businessId,
    associations,
    locations,
    minCpdHours,
    maxCpdHours,
    contentType,
    isBookmarkedOnly,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    loadMore: ({ loadMoreContent, searchResult, filter }) => () => {
      loadMoreContent(searchResult.searchTiles.length, filter);
    }
  }),
  branch(
    ({ isFetchingContent }) => isFetchingContent,
    renderComponent(Loading)
  ),
  branch(
    ({ isFetching, searchResult, searchQuery }) => !isFetching && searchResult.hits === 0 && searchQuery,
    renderComponent(NoSearchResult)
  ),
  branch(
    ({ isFetching, searchResult, searchQuery }) => !isFetching && searchResult.hits === 0 && !searchQuery,
    renderComponent(NoContentMessage)
  )
)(ContentList);



// WEBPACK FOOTER //
// ./src/containers/pages/app/training/partials/content-list.js